/* tslint:disable */
import { Injectable } from '@angular/core';

import { XpoSnackBar, XpoSnackBarConfig } from '@xpo/common';

// These are the custom status codes that are displayed, by adding one it will over-ride the use case and show it
// Not having a code here will revert it to show the general code IE 200, 400, 500

const statusCodes = [
  { flag: 'success', status: 200, summary: 'Successful Server Return', detail: 'The request has succeeded. The information returned with the response is dependent on the method used in the request.' },
  { flag: 'success', status: 201, summary: 'Item Created on Server', detail: 'The request has been fulfilled and resulted in a new resource being created.' },
  { flag: 'error', status: 400, summary: 'Bad Request', detail: 'The server cannot or will not process the request due to an apparent client error.' },
  { flag: 'error', status: 401, summary: 'Unauthorized', detail: 'Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet been provided.' },
  { flag: 'error', status: 403, summary: 'Forbidden', detail: 'The request was valid, but the server is refusing action. The user might not have the necessary permissions for a resource, or may need an account of some sort.' },
  { flag: 'error', status: 404, summary: 'Page Not Found', detail: 'Were sorry, but we could not find the page you are looking for.' },
  { flag: 'error', status: 405, summary: 'Method Not Allowed', detail: 'A request method is not supported for the requested resource.' },
  { flag: 'error', status: 422, summary: 'Unprocessable Entity', detail: 'The server understands the content type of the request entity but was unable to process the contained instructions.' },
  { flag: 'error', status: 500, summary: 'Internal Server Error', detail: 'We apologize for the inconvenience. The issue has been logged and we will be working to correct it.' },
];

export interface StatusCode {
  flag: string;
  status: number;
  summary: string;
  detail: string;
}

@Injectable()
export class AppMessageService {

  constructor(private snackBar: XpoSnackBar) { }

  private showMessenger(message: string): void {
    const setAutoHide: boolean = true;
    const autoHide: number = 1000;
    const config = new XpoSnackBarConfig();
    config.duration = setAutoHide ? autoHide : 0;
    this.snackBar.open(message, false ? '' : undefined, config);
  }

  private getStatusDetails(code: number): StatusCode {
    let tmp = statusCodes.filter((cde) => cde.status == code);
    if (tmp.length === 0) {
      code = this.filterCodeReturn(code);
      tmp = statusCodes.filter((cde) => cde.status == code);
    }
    const retValue: StatusCode = tmp[0];
    return retValue;
  }

  private filterCodeReturn(code: number): number {
    if (code >= 200 && code < 300) {
      code = 200;
    } else if (code > 400 && code < 500) {
      code = 400;
    } else if (code >= 500) {
      code = 500;
    } else if (code >= 300 && code < 400) {
      code = 1;
    } else if (code < 500) {
      code = 1;
    }
    return code;
  }

  // Public Classes for use by the service

  public httpStatusCode(code: number): void {
    const retCodeInfo: StatusCode = this.getStatusDetails(code);
    if (retCodeInfo.status != 1) {
      this.showMessenger(retCodeInfo.summary);
    }
  }

  public saveSuccess(): void {
    this.showMessenger('Your Item was Saved');
  }

  public saveError(): void {
    this.showMessenger('Your Item was not Saved');
  }

  public deleteSuccess(): void {
    this.showMessenger('Your Item was Removed');
  }

  public deleteError(): void {
    this.showMessenger('Your Item was not Removed');
  }

  public loggedIn(): void {
    this.showMessenger('Logging In');
  }

  public loggedOut(): void {
    this.showMessenger('Logging Out');
  }

}



// WEBPACK FOOTER //
// ./src/shared/hms.service.ts